import React, { useState } from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';
import { LEVEL_META, LEVEL_ORDER, fmtK, Title, Panel, ProgressBar } from './bbShared';

export const PROFILE_GROUPS = [
  { k: 'commercial', l: 'Commerciaux', roles: ['commercial', 'commerciale'] },
  { k: 'bm', l: 'Business Managers', roles: ['business_manager'] },
  { k: 'dr', l: 'Directeurs régionaux (DR)', roles: ['directeur_regional', 'dr'] },
  { k: 'dc', l: 'Directeurs commerciaux', roles: ['directeur_commercial'] },
  { k: 'admin', l: 'Direction / Admin', roles: null },
];

const groupOf = (role) => (PROFILE_GROUPS.find(g => g.roles && g.roles.includes(role)) || PROFILE_GROUPS[4]).k;

const sum = (rows, f) => rows.reduce((s, r) => s + f(r), 0);

const Cells = ({ r, objectif, bold }) => (
  <>
    {LEVEL_ORDER.map(k => (
      <td key={k} className="pr-3 py-3"><b className={bold ? 'text-base' : ''}>{r.levels[k].count}</b><span className="text-slate-400"> · {r.levels[k].count ? fmtK(r.levels[k].run_rate) : '—'}</span></td>
    ))}
    <td className={`pr-3 font-bold ${r.besoin_aide ? 'text-[#C8372D]' : 'text-slate-400'}`}>{r.besoin_aide}</td>
    <td className="pr-3 font-semibold">{r.actifs}</td>
    <td className="pr-3 font-bold">{r.signes_periode}</td>
    <td className="min-w-[160px] pr-3">{objectif ? (
      <div className="flex items-center gap-2"><ProgressBar value={r.objectif_realise} max={objectif} /><b className="whitespace-nowrap">{r.objectif_realise} / {objectif}</b></div>
    ) : <span className="text-xs text-slate-400" title="Pas d'objectif prospects pour ce profil">Pas d'objectif</span>}</td>
  </>
);

const aggregate = (rows) => ({
  levels: Object.fromEntries(LEVEL_ORDER.map(k => [k, { count: sum(rows, r => r.levels[k].count), run_rate: sum(rows, r => r.levels[k].run_rate) }])),
  besoin_aide: sum(rows, r => r.besoin_aide), actifs: sum(rows, r => r.actifs),
  signes_periode: sum(rows, r => r.signes_periode), objectif_realise: sum(rows, r => r.objectif_realise),
});

export const ParProfil = ({ rows, params, period, onDetail }) => {
  const [open, setOpen] = useState({});
  const obj = params.objectif_contrats_par_commercial;
  const year = new Date(params.date_fin_objectif || Date.now()).getFullYear();
  return (
    <Panel testId="bb-par-profil">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <Title className="text-xl">Par profil · créateur de la simulation</Title>
        <span className="text-xs text-slate-500">Objectif annuel commerciaux : {obj} contrats prospects (nouveaux corners) signés entre le 01/01 et le 31/12/{year} · pas d'objectif pour BM, DR, Directeurs commerciaux et Direction</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[900px]">
          <thead><tr className="text-[10px] uppercase tracking-[0.12em] text-slate-500 text-left">
            <th className="py-2 pr-3">Profil / créateur</th>{LEVEL_ORDER.map(k => <th key={k} className="pr-3">{LEVEL_META[k].label}</th>)}
            <th className="pr-3">Besoin d'aide</th><th className="pr-3">En cours</th><th className="pr-3">Signés · {period === 'month' ? 'mois' : 'semaine'}</th><th className="pr-3">Objectif annuel</th><th />
          </tr></thead>
          <tbody>
            {PROFILE_GROUPS.map(g => {
              const members = rows.filter(r => groupOf(r.role) === g.k);
              if (!members.length) return null;
              const isOpen = !!open[g.k];
              return (
                <React.Fragment key={g.k}>
                  <tr className="border-t-2 border-[#E5E3DE] bg-[#F7F6F3] cursor-pointer hover:bg-[#EEECE8]" onClick={() => setOpen(o => ({ ...o, [g.k]: !o[g.k] }))} data-testid={`bb-group-${g.k}`}>
                    <td className="py-3 pr-3 font-bold text-[15px]"><span className="inline-flex items-center gap-1.5">{isOpen ? <ChevronDown className="w-4 h-4 text-[#F26A1B]" /> : <ChevronRight className="w-4 h-4 text-[#F26A1B]" />}{g.l} <span className="text-slate-400 font-semibold">({members.length})</span></span></td>
                    <Cells r={aggregate(members)} objectif={g.k === 'commercial' ? obj * members.length : null} bold />
                    <td className="pr-2 text-right"><span className="text-xs font-bold text-[#F26A1B] underline" data-testid={`bb-group-toggle-${g.k}`}>{isOpen ? 'Masquer' : 'Détail'}</span></td>
                  </tr>
                  {isOpen && members.map(r => (
                    <tr key={r.commercial_id} className="border-t border-[#EEECE8]" data-testid={`bb-com-${r.commercial_id}`}>
                      <td className="py-3 pr-3 pl-7 font-semibold">{r.name}</td>
                      <Cells r={r} objectif={g.k === 'commercial' ? obj : null} />
                      <td className="pr-2 text-right">
                        <button type="button" onClick={() => onDetail(r)} className="inline-flex items-center gap-0.5 text-xs font-bold text-[#25272B] hover:text-[#F26A1B]" data-testid={`bb-com-detail-${r.commercial_id}`}>Détail<ChevronRight className="w-3.5 h-3.5" /></button>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </Panel>
  );
};
